<h2 mat-dialog-title class="mb-1 fs-3">Kétfaktoros azonosítás</h2>
<button type="button" mat-icon-button (click)="close()" class="close-btn">
  <mat-icon>close</mat-icon>
</button>

<mat-dialog-content>
  @if (loading()) {
    <div class="d-flex justify-content-center p-4">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  } @else {
    <!-- ================= TOTP ================= -->
    <div class="card mb-3">
      <div class="card-body">
        <div class="d-flex align-items-center mb-2">
          <i class="material-icons me-2">smartphone</i>
          <h5 class="card-title mb-0 flex-grow-1">Hitelesítő alkalmazás (TOTP)</h5>
          @if (totpEnabled()) {
            <span class="badge bg-success">Bekapcsolva</span>
          } @else {
            <span class="badge bg-secondary">Kikapcsolva</span>
          }
        </div>

        @if (totpEnabled()) {
          <div class="d-flex gap-2 align-items-center mt-2">
            <input class="form-control form-control-sm" style="max-width: 220px"
                   placeholder="Aktuális kód a kikapcsoláshoz" [formControl]="disableTotpCode" />
            <button class="btn btn-outline-danger btn-sm" [disabled]="busy()"
                    (click)="disable('TOTP')">Kikapcsolás</button>
          </div>
        } @else if (totpSetup()) {
          <p class="text-muted small mb-2">
            Olvassa be a QR-kódot a hitelesítő alkalmazással (Google Authenticator, Authy…),
            majd adja meg az első 6 jegyű kódot.
          </p>
          <div class="text-center mb-2">
            <img [src]="qrDataUri()" alt="TOTP QR" width="200" height="200" />
          </div>
          <div class="text-break small text-muted mb-2">{{ totpSetup()!.otpAuthUri }}</div>
          <div class="d-flex gap-2 align-items-center">
            <input class="form-control" style="max-width: 200px" placeholder="6 jegyű kód"
                   [formControl]="totpCode" />
            <button class="btn btn-primary" [disabled]="busy()" (click)="activateTotp()">Aktiválás</button>
          </div>
        } @else {
          <p class="text-muted small mb-2">Időalapú egyszeri kód hitelesítő alkalmazásból.</p>
          <button class="btn btn-primary" [disabled]="busy()" (click)="beginTotp()">Beállítás indítása</button>
        }

        @if (recoveryCodes()) {
          <div class="alert alert-warning mt-3 mb-0">
            <div class="fw-bold mb-1">Helyreállító kódok</div>
            <div class="small mb-2">Mentse el ezeket most — később nem jeleníthetők meg újra.</div>
            <div class="d-flex flex-wrap gap-2 mb-2">
              @for (rc of recoveryCodes(); track rc) {
                <code class="bg-white border rounded px-2 py-1">{{ rc }}</code>
              }
            </div>
            <button class="btn btn-outline-secondary btn-sm" (click)="copyRecoveryCodes()">
              <i class="material-icons align-middle" style="font-size: 16px">content_copy</i> Másolás
            </button>
          </div>
        }
      </div>
    </div>

    <!-- ================= EMAIL ================= -->
    <div class="card mb-3">
      <div class="card-body">
        <div class="d-flex align-items-center mb-2">
          <i class="material-icons me-2">email</i>
          <h5 class="card-title mb-0 flex-grow-1">E-mail alapú kód</h5>
          @if (emailEnabled()) {
            <span class="badge bg-success">Bekapcsolva</span>
          } @else {
            <span class="badge bg-secondary">Kikapcsolva</span>
          }
        </div>

        @if (emailEnabled()) {
          <div class="d-flex gap-2 align-items-center mt-2">
            <button class="btn btn-outline-secondary btn-sm" [disabled]="busy()"
                    (click)="sendEmailLoginCode()">Kód küldése</button>
            <input class="form-control form-control-sm" style="max-width: 200px"
                   placeholder="Kód a kikapcsoláshoz" [formControl]="disableEmailCode" />
            <button class="btn btn-outline-danger btn-sm" [disabled]="busy()"
                    (click)="disable('EMAIL')">Kikapcsolás</button>
          </div>
        } @else {
          <p class="text-muted small mb-2">Egyszeri kód a felhasználó e-mail címére.</p>
          @if (emailEnrollSent()) {
            <div class="d-flex gap-2 align-items-center">
              <input class="form-control" style="max-width: 200px" placeholder="E-mailben kapott kód"
                     [formControl]="emailCode" />
              <button class="btn btn-primary" [disabled]="busy()" (click)="activateEmail()">Aktiválás</button>
              <button class="btn btn-link btn-sm" [disabled]="busy()" (click)="sendEmailEnroll()">Újraküldés</button>
            </div>
          } @else {
            <button class="btn btn-primary" [disabled]="busy()" (click)="sendEmailEnroll()">Aktiváló kód küldése</button>
          }
        }
      </div>
    </div>

    <!-- ================= VERIFY TESTER ================= -->
    @if (anyEnabled()) {
      <div class="card">
        <div class="card-body">
          <div class="d-flex align-items-center mb-2">
            <i class="material-icons me-2">check_circle</i>
            <h5 class="card-title mb-0">Kipróbálás</h5>
          </div>
          <p class="text-muted small mb-2">Ellenőrizze, hogy egy kód érvényes-e (nem befolyásolja a bejelentkezést).</p>
          <div class="d-flex flex-wrap gap-2 align-items-center">
            <mat-form-field appearance="outline" class="method-select">
              <mat-label>Módszer</mat-label>
              <mat-select [formControl]="verifyMethod">
                @if (totpEnabled()) { <mat-option value="TOTP">Hitelesítő app</mat-option> }
                @if (emailEnabled()) { <mat-option value="EMAIL">E-mail</mat-option> }
                <mat-option value="RECOVERY">Helyreállító kód</mat-option>
              </mat-select>
            </mat-form-field>
            @if (verifyMethod.value === 'EMAIL') {
              <button class="btn btn-outline-secondary btn-sm" [disabled]="busy()"
                      (click)="sendEmailLoginCode()">Kód küldése</button>
            }
            <input class="form-control" style="max-width: 200px" placeholder="Kód" [formControl]="verifyCode" />
            <button class="btn btn-primary" [disabled]="busy()" (click)="verify()">Ellenőrzés</button>
          </div>
        </div>
      </div>
    }
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Bezárás</button>
</mat-dialog-actions>
